import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useDispatch, useSelector } from "react-redux";
import { clearDeviceConfigState } from "features/deviceConfig/deviceConfigSlice";

function CommandCard() {
  const dispatch = useDispatch();
  const deviceData = useSelector((state) => state.deviceConfig.deviceData);
  const heatDetails = useSelector((state) => state.deviceConfig.heatDetails);
  const intervalId = useSelector((state) => state.deviceConfig.intervalId);

  const handleClearDevice = () => {
    // Chalu polling/API call ko band karo
    if (intervalId) {
      clearInterval(intervalId);
    }
    
    dispatch(clearDeviceConfigState());
  };

  return (
    deviceData &&
    heatDetails && (
      <MDBox
        sx={{
          p: 3,
          maxWidth: 500,
          margin: "auto",
        }}
      >
        <MDTypography variant="h5" fontWeight="medium" gutterBottom>
          Device Command
        </MDTypography>

        <MDBox mb={2}>
          <MDTypography variant="button" fontWeight="regular" mb={0.5}>
            Protocol Type
          </MDTypography>
          <MDInput
            label="Select The Command Type"
            variant="outlined"
            fullWidth
            size="small"
          />
        </MDBox>

        <MDBox mb={3}>
          <MDTypography variant="button" fontWeight="regular" mb={0.5}>
            Command
          </MDTypography>
          <MDInput
            label="Select The Command"
            variant="outlined"
            fullWidth
            size="small"
          />
        </MDBox>

        <MDBox display="flex" justifyContent="flex-end" gap={2}>
          <MDButton variant="outlined" color="error">
            Cancel
          </MDButton>
          <MDButton variant="contained" color="info" onClick={handleClearDevice}>
            Clear Device
          </MDButton>
        </MDBox>
      </MDBox>
    )
  );
}

export default CommandCard;